import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type { ReactNode } from 'react';

interface InfoHintProps {
    title: ReactNode;
    size?: 'small' | 'inherit' | 'medium' | 'large';
    sx?: object;
}

/**
 * Small information indicator rendered as an `InfoOutlined` icon that shows
 * the provided explanation inside a tooltip on hover / focus. Used across
 * the Salary page to explain how each feature works.
 */
const InfoHint = ({ title, size = 'small', sx }: InfoHintProps) => (
    <Tooltip title={title} arrow enterDelay={100}>
        <InfoOutlinedIcon
            fontSize={size}
            color="action"
            sx={{ cursor: 'help', verticalAlign: 'middle', ml: 0.5, ...sx }}
            tabIndex={0}
            aria-label="info"
        />
    </Tooltip>
);

export default InfoHint;
